import React, { useEffect, useState } from 'react';
import cx from 'classnames';

const FollowButton = ({ following = false, className, onFollow }) => {
  const [isFollowing, setIsFollowing] = useState(!!following);

  useEffect(() => {
    setIsFollowing(!!following);
  }, [following]);

  const handleClick = (e) => {
    onFollow?.(e);
    setIsFollowing((prev) => !prev);
  };

  return (
    <button
      onClick={handleClick}
      className={cx('cz-btn-outline', {
        lightgray: isFollowing,
        black: !isFollowing,
        [className]: className,
      })}
    >
      {isFollowing ? 'Unfollow' : 'Follow'}
    </button>
  );
};

export default FollowButton;
